<template>
  <w-dropdown>
    <template #trigger>
      <w-dropdown-trigger :style="{ display: 'flex' }">
        <w-profile-image
          v-if="isLogin"
          :image-url="profileImage.url"
          :alt="profileImage.alt"
        />
        <w-user-icon v-else width="22" height="22" color="#A5A5A5" />
      </w-dropdown-trigger>
    </template>
    <template #menu>
      <transition name="fade" appear>
        <w-dropdown-menu class="my-dropdown-menu" space="26" z-index="1200">
          <div v-if="isLogin" class="my-profile-section">
            <w-profile-image
              v-if="isLogin"
              :image-url="profileImage.url"
              :alt="profileImage.alt"
              width="52"
              height="52"
            />
            <div class="my-profile-text">
              <div class="profile-name">{{ userName }}</div>
              <template v-if="profileCount > 1">
                <router-link
                  to="/member/profile_change.html"
                  class="profile-link"
                  data-util-menu="true"
                >
                  사용자 변경
                </router-link>
              </template>
              <template v-else>
                <w-link
                  class="profile-link"
                  data-util-menu="true"
                  @click="profileEditUrl"
                >
                  프로필 편집
                </w-link>
                <a
                  href="#"
                  class="a11y-hidden"
                  data-util-menu="true"
                  @click.prevent="profileEditUrl"
                >
                  프로필 이미지 변경
                </a>
              </template>
            </div>
          </div>
          <w-profile-menu-list
            :is-login="isLogin"
            :voucher-count="voucherCount"
          />
        </w-dropdown-menu>
      </transition>
    </template>
  </w-dropdown>
</template>

<script setup>
  import WDropdown from '@/components/dropdown/WDropdown'
  import WDropdownTrigger from '@/components/dropdown/WDropdownTrigger'
  import WDropdownMenu from '@/components/dropdown/WDropdownMenu'
  import WProfileImage from '@/components/profile/WProfileImage'
  import WUserIcon from '@/components/header/icon/WUserIcon'
  import WLink from '@/components/link/WLink'
  import WProfileMenuList from '@/components/header/profile/WProfileMenuList'
</script>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import { getMySummary } from '@/common/utils/request'

  export default {
    data() {
      return {
        voucherCount: 0,
      }
    },
    computed: {
      ...mapGetters(['menuState', 'csInfo']),
      profileImage() {
        return {
          url:
            this.csInfo.profileimage || 'img.wavve.com/service30/profile/0.png',
          alt: this.csInfo.alt || '',
        }
      },
      userName() {
        return this.csInfo.profilename || '회원님'
      },
      profileCount() {
        return this.csInfo.profilecount
      },
      isLogin() {
        return !!this.csInfo
      },
    },
    mounted() {
      this.initialize()
    },
    methods: {
      ...mapMutations(['showLoginPopup', 'hideLoginPopup']),
      profileEditUrl() {
        if (location.href.indexOf('member/profile_edit.html') > -1)
          return '/member/profile_edit.html?profileId=0'
        this.$router.push(
          '/member/profile_edit.html?profileId=0&referer=' +
            encodeURIComponent(location.href),
        )
      },
      async initialize() {
        const voucherData = await getMySummary()
        this.voucherCount = voucherData?.data?.mypass?.length ?? 0
      },
    },
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .my-dropdown-menu {
    right: 0;
    backgroundcolor: #101010;
    .my-profile-section {
      display: flex;
      align-items: center;
      padding: 28px;
      border-bottom: 1px solid #252525;
      .my-profile-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 88px;
        margin-left: 12px;
        .profile-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;
          color: #fff;
          padding-bottom: 2px;
        }
        .profile-link {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: #a5a5a5;
          text-decoration: none;
        }
      }
    }
  }
</style>
